// One tab stop per choice group; arrows/Home/End move and select the choice.
export function radioGroupKeys(event) {
  const keys=['ArrowRight','ArrowDown','ArrowLeft','ArrowUp','Home','End'];
  if(!keys.includes(event.key) || event.target.getAttribute('role')!=='radio') return;
  const choices=[...event.currentTarget.querySelectorAll('[role="radio"]')].filter(e=>!e.disabled);
  const current=choices.indexOf(event.target); if(current<0 || !choices.length)return;
  event.preventDefault();
  const index=event.key==='Home'?0:event.key==='End'?choices.length-1:(current+(['ArrowRight','ArrowDown'].includes(event.key)?1:-1)+choices.length)%choices.length;
  choices[index].focus(); choices[index].click();
}
